import distance from "@turf/distance";
import { point } from "@turf/helpers";

import { GEOGRAPHICAL_REGIONS_CONFIG } from "lookup";

export const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const from = point([lng1, lat1]);
  const to = point([lng2, lat2]);
  const distanceKm = distance(from, to, { units: "kilometers" });
  const convertedToMiles = distanceKm / 1.60934;
  return convertedToMiles;
};

export const isWithinRadius = (userLocation, jobLocation, radiusMiles) => {
  if (
    !userLocation?.latitude ||
    !userLocation?.longitude ||
    !jobLocation?.latitude ||
    !jobLocation?.longitude
  ) {
    return false;
  }

  const distanceMiles = calculateDistance(
    userLocation.latitude,
    userLocation.longitude,
    jobLocation.latitude,
    jobLocation.longitude
  );

  return distanceMiles <= radiusMiles;
};

export const getAllowedCountryNamesForJobRegions = (
  geographicalRegions,
  regionsConfig = GEOGRAPHICAL_REGIONS_CONFIG
) => {
  if (!geographicalRegions?.length) {
    return [];
  }

  return geographicalRegions
    .map((grOuter) => {
      if (!grOuter?.countryNames?.length) {
        const match = regionsConfig?.find(
          (grInner) => grInner.regionName === grOuter.regionName
        );
        return match?.countryNames?.length ? [...match.countryNames] : [];
      }
      return [...grOuter.countryNames];
    })
    .flat();
};

export const getGeographicalRegionsFilterDescription = (
  geographicalRegions
) => {
  if (!geographicalRegions?.length) {
    return "";
  }

  return geographicalRegions
    .map((region) => {
      if (!region?.countryNames?.length) {
        return region.regionName;
      }
      return region.countryNames.join(", ");
    })
    .join(", ");
};

export const isInGeographicalRegions = (userLocation, geographicalRegions) => {
  if (!userLocation?.countryName || !geographicalRegions?.length) {
    return false;
  }

  const allowedCountries = getAllowedCountryNamesForJobRegions(
    geographicalRegions,
    GEOGRAPHICAL_REGIONS_CONFIG
  );

  if (!allowedCountries.length) {
    return false;
  }

  const userCountry = userLocation.countryName.toLowerCase();
  return allowedCountries.some(
    (country) => country.toLowerCase() === userCountry
  );
};

export const filterUsersByLocation = (users, jobOpp, radiusMiles) => {
  if (!users || !Array.isArray(users)) {
    return [];
  }

  if (
    !jobOpp ||
    (!jobOpp.location?.latitude && !jobOpp.geographicalRegions?.length)
  ) {
    return users;
  }

  if (jobOpp.location?.latitude && jobOpp.location?.longitude) {
    return users.filter((user) => {
      if (!user.location) {
        return false;
      }

      return isWithinRadius(user.location, jobOpp.location, radiusMiles);
    });
  }

  if (jobOpp.geographicalRegions?.length) {
    return users.filter((user) => {
      if (!user.location) {
        return false;
      }

      return isInGeographicalRegions(user.location, jobOpp.geographicalRegions);
    });
  }

  return users;
};
